import React, { useEffect, useState } from "react";
import theme from "@theme";
import { Button, Tabs } from "InnoUI/components";
import { apiPost } from "api/callApi";
import { DrawerHeader } from "@components/";
import ProjectList from "./ProjectList";
import OccupantList from "./OccupantList";

const FolderTemplateEditor = (props) => {
  const {
    onClose,
    selectedProjects = [],
    selectedOccupants = [],
    setSelectedProjects = () => {},
    setSelectedOccupants = () => {},
    data = {},
  } = props;
  const [selectedTab, setSelectedTab] = useState(0);
  const [checkedProjects, setCheckedProjects] = useState([]);
  const [checkedOccupants, setCheckedOccupants] = useState([]);

  const tabData = [
    { value: 0, label: `Projects` },
    { value: 1, label: "Occupants" },
  ];

  const handleTabChange = (event, newValue) => {
    setSelectedTab(newValue);
  };

  useEffect(() => {
    if (checkedProjects.length == 0 || checkedOccupants.length == 0) {
      setCheckedProjects(selectedProjects);
      setCheckedOccupants(selectedOccupants);
    }
  }, [selectedProjects, selectedOccupants]);

  const handleSave = async () => {
    try {
      setSelectedProjects(checkedProjects);
      setSelectedOccupants(checkedOccupants);
      onClose();
    } catch (error) {
      console.log("Error: " + error.message);
    }
  };

  return (
    <>
      <DrawerHeader
        title="Edit Folder Template Structure Sync with linked projects"
        onClose={onClose}
      />
      <div style={{ marginLeft: "15px", display: "flex" }}>
        <Tabs
          value={selectedTab}
          label={tabData.map((tab) => tab.label) || []}
          onChange={handleTabChange}
          selectedValue={selectedTab}
        />

        <div style={{ display: "flex", gap: "10px", margin: "10px" }}>
          <Button
            caption="Cancel"
            onClick={onClose}
            fontSize="12px"
            style={{
              marginBottom: 8,
              background: theme.colors.cancelButton,
              color: theme.colors.white,
              minWidth: "90px",
              borderRadius: "3px",
              height: "30px",
              fontSize: "12px",
            }}
          />
          <Button
            caption={"Save"}
            onClick={handleSave}
            color="white"
            fontSize="12px"
            style={{
              marginBottom: 8,
              background: theme.gradient.themeGradient,
              color: theme.colors.white,
              minWidth: "90px",
              height: "30px",
              borderRadius: "3px",
            }}
          />
        </div>
      </div>

      {selectedTab == 0 && (
        <ProjectList
          projectData={data.projectData}
          checkedProjects={checkedProjects}
          setCheckedProjects={setCheckedProjects}
          selectedProjects={selectedProjects}
        />
      )}
      {selectedTab == 1 && (
        <OccupantList
          occupantData={data.occupantData}
          checkedOccupants={checkedOccupants}
          setCheckedOccupants={setCheckedOccupants}
          selectedOccupants={selectedOccupants}
        />
      )}
    </>
  );
};

export default FolderTemplateEditor;
